/**
 * @generated SignedSource<<87880e5bcf29a0fcb177f210c7d97e61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FileLinkDeleteInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type RemoveFileLink_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: FileLinkDeleteInput;
};
export type RemoveFileLink_Mutation$data = {
  readonly removeFileLink: {
    readonly deletedFileLinkIds: ReadonlyArray<string>;
  };
};
export type RemoveFileLink_Mutation = {
  response: RemoveFileLink_Mutation$data;
  variables: RemoveFileLink_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedFileLinkIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveFileLink_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "FileLinkDeletePayload",
        "kind": "LinkedField",
        "name": "removeFileLink",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RemoveFileLink_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "FileLinkDeletePayload",
        "kind": "LinkedField",
        "name": "removeFileLink",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedFileLinkIds",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "499ec17793eef57d00d4ad8c76220abf",
    "id": null,
    "metadata": {},
    "name": "RemoveFileLink_Mutation",
    "operationKind": "mutation",
    "text": "mutation RemoveFileLink_Mutation(\n  $input: FileLinkDeleteInput!\n) {\n  removeFileLink(input: $input) {\n    deletedFileLinkIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "37fd8363d1ba0731c5fa09a7cc492907";

export default node;
